export default __webpack_public_path__ + "static/media/setAvaliabilityIcon.f63ef1d6.svg";